module.exports = __webpack_public_path__ + "static/img/loan.0411d6eb.svg";